import { ChakraBaseProvider, Flex, Box } from '@chakra-ui/react';
import claverTheme from '../../layout/components/layout/components/theme/claverTheme';
import GeneralPageFooter from './GeneralPageFooter';
import PublicUserHeader from './PublicUserHeader';
import PasswordResetForm from './PasswordResetForm';


export default function PasswordResetPage() {
		
	return (
		<ChakraBaseProvider theme={claverTheme}>
			<PublicUserHeader signUpEnabled/>
			<Box w='100%' px='2em' className="authentication-container">

				<Flex direction='column' minH='20em' py='5em' mx='auto'>

					<Flex direction='row' flexGrow='1'>
						<Flex p={['1em','2em']} w='100%' maxW='35em' direction='column' mx='auto' justify='center' alignItems='center' bg='white' rounded='0.25em' className="default-box-shadow">
			
							<Box fontSize='1.4em' color='brandDark.500'>Reset Password</Box>
							<Box mt='0.5em' fontSize='0.875em' color='gray.500' textAlign='center'>Which email address did you use to create an account with us? </Box>
							<PasswordResetForm  />
				
						</Flex>
					</Flex>

					<GeneralPageFooter />
				</Flex>
			</Box>
		</ChakraBaseProvider>
	);
	
}